import { inject } from '@angular/core';
import { AbstractControl, ControlContainer, Validators } from '@angular/forms';
import { EmailValidationPattern } from '@platform/shared/utilities/validation-utility';

/* viewProviders: [provideParentFormGroup()] */
export const provideParentFormGroup = () => ({
  provide: ControlContainer,
  useFactory: () => inject(ControlContainer, { skipSelf: true }),
});

export interface OptionItem<T = string> {
  value: T;
  label: string;
}

export const setControlEnabled = (control: AbstractControl<unknown, unknown> | null, isEnabled: boolean = true) => {
  if (!control) {
    return;
  }
  if (control.enabled === isEnabled) {
    return;
  }

  if (isEnabled) {
    control.enable();
  } else {
    control.disable();
  }
};

export const setControlDisabled = (control: AbstractControl<unknown, unknown> | null) => {
  setControlEnabled(control, false);
};

export const { required, maxLength, pattern } = Validators;
export const emailValidator = () => pattern(EmailValidationPattern);
